export default __webpack_public_path__ + "static/media/premium-platforms.0e8a2033.png";